module.exports = __webpack_public_path__ + "static/media/team.ae185b14.svg";